// =============================================================================
// reducers/incidentReducer.js
//
// State for the Incidents domain.
//
// FIX5 — filtering is server-side but pagination is NOT: `items` holds
// EVERY row matching the current filters (up to the maxRows safety cap sent
// by fetchIncidents), and the table paginates that set in memory.
// `totalCount` is the TRUE match count from the server (even if `items` was
// truncated by the cap), so the UI can warn the operator when that happens.
// =============================================================================
import {
	INCIDENTS_FETCH_REQUEST, INCIDENTS_FETCH_SUCCESS, INCIDENTS_FETCH_FAILURE,
	INCIDENT_HISTORY_FETCH_REQUEST, INCIDENT_HISTORY_FETCH_SUCCESS, INCIDENT_HISTORY_FETCH_FAILURE,
	INCIDENT_SELECT, INCIDENT_FILTER_CHANGE, INCIDENT_FILTER_RESET,
} from '../constants/kpiConstants';

const DEFAULT_FILTERS = {
	status:         'Open',     // 'Open' | 'Closed'
	tech:           'all',
	severity:       'all',
	vendor:         'all',
	kpiName:        'all',
	siteId:         '',
	cellId:         '',
	durationBucket: 'all',      // 'all' | 'lt1' | '1to3' | '4to7' | '8to30' | '31to90' | 'gt90'
};

const initialState = {
	items:          [],
	totalCount:     0,
	loading:        false,
	loaded:         false,
	error:          null,

	selected:       null,
	history:        [],
	historyLoading: false,
	historyError:   null,

	filters: Object.assign({}, DEFAULT_FILTERS),
};

export default function incidentReducer(state, action) {
	if (state === undefined) state = initialState;

	switch (action.type) {
					case INCIDENTS_FETCH_REQUEST:
						return Object.assign({}, state, { loading: true, error: null });

					case INCIDENTS_FETCH_SUCCESS: {
						// payload = { items, totalCount } (PagedResultDto — totalCount is
						// the real match count, even if items was capped by maxRows)
						const p = action.payload || {};
						return Object.assign({}, state, {
							loading:    false,
							loaded:     true,
							items:      p.items || [],
							totalCount: p.totalCount || 0,
							error:      null,
						});
					}

					case INCIDENTS_FETCH_FAILURE:
						return Object.assign({}, state, { loading: false, error: action.payload });

					case INCIDENT_HISTORY_FETCH_REQUEST:
						return Object.assign({}, state, { historyLoading: true, historyError: null, history: [] });
					case INCIDENT_HISTORY_FETCH_SUCCESS:
						return Object.assign({}, state, { historyLoading: false, history: action.payload });
					case INCIDENT_HISTORY_FETCH_FAILURE:
						return Object.assign({}, state, { historyLoading: false, historyError: action.payload });

					case INCIDENT_SELECT:
						return Object.assign({}, state, { selected: action.payload, history: [] });

					case INCIDENT_FILTER_CHANGE:
						return Object.assign({}, state, {
							filters: Object.assign({}, state.filters, action.payload),
						});

					case INCIDENT_FILTER_RESET:
						return Object.assign({}, state, {
							filters: Object.assign({}, DEFAULT_FILTERS),
						});

					default:
						return state;
	}
}